import { render, staticRenderFns } from "./SingleIntegrationHooks.vue?vue&type=template&id=193c1910&"
import script from "./SingleIntegrationHooks.vue?vue&type=script&lang=js&"
export * from "./SingleIntegrationHooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports